"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.canExcludeCurrentPeriod = exports.applyExcludeCurrentPeriod = void 0;
var tslib_1 = require("tslib");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
/**
 * Returns the date filter option with excludeCurrentPeriod applied if applicable.
 */
exports.applyExcludeCurrentPeriod = function (dateFilterOption, excludeCurrentPeriod) {
    if (!dateFilterOption || !excludeCurrentPeriod) {
        return dateFilterOption;
    }
    if (sdk_backend_spi_1.isAllTimeDateFilterOption(dateFilterOption) ||
        sdk_backend_spi_1.isAbsoluteDateFilterForm(dateFilterOption) ||
        sdk_backend_spi_1.isAbsoluteDateFilterPreset(dateFilterOption) ||
        sdk_backend_spi_1.isRelativeDateFilterForm(dateFilterOption)) {
        return dateFilterOption;
    }
    else if (sdk_backend_spi_1.isRelativeDateFilterPreset(dateFilterOption)) {
        var from = dateFilterOption.from, to = dateFilterOption.to;
        var shouldExcludeCurrent = to === 0 && from < to;
        return tslib_1.__assign(tslib_1.__assign({}, dateFilterOption), { from: shouldExcludeCurrent ? dateFilterOption.from - 1 : dateFilterOption.from, to: shouldExcludeCurrent ? -1 : to });
    }
    else {
        throw new Error("Unknown date filter value type");
    }
};
exports.canExcludeCurrentPeriod = function (dateFilterOption) {
    if (!dateFilterOption.visible) {
        return false;
    }
    if (sdk_backend_spi_1.isRelativeDateFilterPreset(dateFilterOption)) {
        return dateFilterOption.to === 0 && dateFilterOption.from < dateFilterOption.to;
    }
    return false;
};
//# sourceMappingURL=PeriodExclusion.js.map